import * as React from 'react';
import { useRecordContext } from 'react-admin';

import { makeStyles, Typography } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import moment from 'moment';

import {
  TIPO_RECORRENCIA_NAO_RECORRENCIA,
  TIPO_RECORRENCIA_DIARIA_NORMAL,
} from '../../utils';

const useStyles = makeStyles((theme) => ({
  text: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '400px',
  },
}));

const DescricaoField = (props) => {
  const classes = useStyles();

  const record = useRecordContext(props);
  const value = record
    ? record.record.tipo_recorrencia === TIPO_RECORRENCIA_NAO_RECORRENCIA
      ? moment(new Date(record.record.data_entrega)).format('DD/MM/YYYY')
      : '-'
    : '-';

  return (
    <Tooltip title={value} placement="bottom" aria-label="add2">
      <Typography className={classes.text}>{value}</Typography>
    </Tooltip>
  );
};

export default DescricaoField;
